import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchAttendanceLeaveType, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraHoursReport, fetchForm34ReportRequest, fetchLeaveBalanceReportRequest, fetchLeaveReportRequest, getMobilePunchReport, resetAttendanceReport } from "store/actions";
import Loader from "common/pageLoader";
import Swal from "sweetalert2";

const AttendanceReportForm34 = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    dropdownAutoList,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      category: null,
      department: null,
      empCode: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      // console.log("Search with values:", values);
      const formData = new FormData();
      formData.append("dep_id", values.department || 0);
      formData.append("cat_id", values.category || 0);
      formData.append("emp_code", values.employee || 0);
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);

      dispatch(fetchForm34ReportRequest(formData));
    },
  });

  const columns = [    
    { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", },
    { Header: "Code", accessor: "emp_code" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Department", accessor: "department" },
    { Header: "DOJ", accessor: "date_of_joining" },   
    {
      Header: "Action",
      // accessor: "form34",
      Cell: ({ row }) => (
        <Button
          color="link"
          onClick={() =>
            Swal.fire({
              title: "Form 34",
              text: `Form 34 is opened for Emp Code: ${row.original.emp_code}`,
              icon: "info",
              confirmButtonText: "OK",
            })
          }
        >
          FORM 34
        </Button>
      ),
    }, 
  ];

  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetAttendanceReport()); 
  };

  return (
    <div className="page-content">
      <Loader loading={loading}/>
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Form 34" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3 align-items-end">
                <Col md={3}>
                    <Label>Category</Label>
                    <CustomSelect
                      id="category"
                      name="category"
                      options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                      value={
                        categories
                          .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                          .find(cat => cat.value === formik.values.category) || null
                      }
                      onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                    />
                  </Col>                

                  <Col md={3}>
                    <Label>Department</Label>
                    <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                        value={
                          departments
                            .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                            .find(dept => dept.value === formik.values.department) || null
                        }
                        onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                        onBlur={formik.handleBlur}
                        className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                      />
                  </Col>
                  <Col md={3}>
                    <Label>
                      Employee
                    </Label>
                    <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(emp => ({
                          value: String(emp.emp_id),
                          label: emp.emp_no
                        }))}

                        // UI needs the object, so find matching option
                        value={
                          dropdownAutoList
                            .map(emp => ({
                              value: String(emp.emp_id),
                              label: emp.emp_no
                            }))
                            .find(option => option.value === formik.values.employee) || null
                        }

                        // Form Data: store string only
                        onChange={(selected) =>
                          formik.setFieldValue("employee", selected ? selected.value : "")
                        }
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">
                          {formik.errors.employee}
                        </div>
                      )}
                  </Col>
                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 ">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Form34 Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Form34 Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportForm34;
